import React from 'react';
import { navigate, RouteComponentProps } from '@reach/router';
import { Box, Stack } from '@mui/material';
import { ReactComponent as Salesrook } from '@assets/svg/salesrook.svg';
import { ReactComponent as Error404 } from '@assets/svg/404.svg';
import { TextView } from '@atoms';
import { materialTheme } from '@particles';

interface Errors404Props extends RouteComponentProps {
  /** Message to show. Defaults to a not-found message; use 'accessDenied' for permission failures. */
  variant?: 'notFound' | 'accessDenied';
}

const COPY = {
  notFound: {
    heading: 'Page not found',
    message: 'Sorry, this page does not exist. You can go back to'
  },
  accessDenied: {
    heading: 'Access Denied',
    message: 'Sorry, but you do not have permission to access this page. You can go back to'
  }
};

const Errors404: React.FC<Errors404Props> = ({ variant = 'notFound' }) => {
  const { heading, message } = COPY[variant];

  return (
    <Box alignItems={'center'} display={'flex'} flexDirection={'column'}>
      <Salesrook style={{ marginTop: 36 }} />
      <TextView $fontSize={24} mt={8}>
        {heading}
      </TextView>
      <Stack direction={'row'} mt={3} mb={8}>
        <TextView $fontWeight={400}>{message}</TextView>
        <TextView
          $fontWeight={700}
          $fontColor={materialTheme.palette.secondary.main}
          ml={0.6}
          onClick={() => {
            navigate(-1);
          }}
        >
          previous page
        </TextView>
      </Stack>
      <Error404 />
    </Box>
  );
};

export default Errors404;
